export default "__VITE_ASSET__A0jHwEL0__"